const clearCheckboxStore = {
  state: {
    value: false,
  },
  getters: {
    value(state) {
      return state.value;
    },
  },
  mutations: {
    CHANGE(state) {
      state.value = !state.value;
    },
  },
};

export default clearCheckboxStore;
